export function isLoggedIn() {
  return localStorage.getItem('user-token') ?  true : false
}